// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-tab-container {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 4em;
}

.stats-tab-table {
  font-size: var(--font-size-m);
  line-height: 1.5;
  place-self: flex-start;
}

.stats-tab-caption-row > td {
  font-weight: bold;
  padding-top: var(--input-element-gap);
}

.stats-tab-value-row > td:first-child {
  padding-left: var(--input-element-gap);
}

.stats-tab-value-row > td {
  padding-top: 2px;
  padding-bottom: 2px;
}

.stats-tab-table {
  border-collapse: collapse;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/stats-tab/StatsTab.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".stats-tab-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  gap: 4em;\n}\n\n.stats-tab-table {\n  font-size: var(--font-size-m);\n  line-height: 1.5;\n  place-self: flex-start;\n}\n\n.stats-tab-caption-row > td {\n  font-weight: bold;\n  padding-top: var(--input-element-gap);\n}\n\n.stats-tab-value-row > td:first-child {\n  padding-left: var(--input-element-gap);\n}\n\n.stats-tab-value-row > td {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.stats-tab-table {\n  border-collapse: collapse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
